<template>
  <div class="relative bg-primary-800">
    <div class="relative lg:z-10 pb-4 pt-14 lg:py-40">
      <TContainer>
        <TGrid>
          <div
            class="col-span-12 md:col-span-8 md:col-start-3 lg:col-span-4 lg:col-start-2"
          >
            <div class="relative bg-white w-full p-3 rounded-lg m-auto">
              <TSearchBig
                :province-filter="provinceFilter"
                :region-filter="regionFilter"
              />
            </div>
          </div>

          <div
            class="col-span-12 order-first lg:order-0 lg:col-span-6 lg:col-start-7 text-center lg:text-left flex items-center"
          >
            <TTitle
              class="w-full"
              color="text-white"
              tag="h1"
              size="5xl"
              :bold="true"
              :critical="true"
            >
              {{ title }}
            </TTitle>
          </div>
        </TGrid>
      </TContainer>
    </div>

    <div
      v-if="image"
      class="relative lg:absolute lg:z-0 inset-0 aspect-w-3 aspect-h-2 lg:aspect-none"
    >
      <div>
        <TLazyimg :src="image" alt="" />
      </div>
      <div>
        <div
          class="hidden lg:block absolute inset-0 w-full h-full bg-primary-900/40 mix-blend-multiply"
        />
      </div>

      <div v-if="badge">
        <TContainer class="absolute bottom-0 w-full">
          <div class="text-center lg:text-right pb-4 lg:pb-8">
            <UBadge data-test="badge" color="neutral" size="md"
              >{{ badge }}
            </UBadge>
          </div>
        </TContainer>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
export interface propsInterface {
  image: string
  title: string
  badge: string | null
  provinceFilter?: string | null
  regionFilter?: string | null
}

defineProps<propsInterface>()
</script>
